import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from '../../../../../../redux/store';
import { useInvoiceSubmittingStatus } from './useInvoiceSubmittingStatus';
import { getInvoiceBreakdown } from '../../../../../../redux/slices/invoicing';

export function useInvoiceRefreshOnSubmit() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const wasSubmitting = useRef(false);
  const isSubmitting = useInvoiceSubmittingStatus();

  useEffect(() => {
    if (isSubmitting !== wasSubmitting.current) {
      dispatch(getInvoiceBreakdown(id, 'ItemsLog'));
    }
    wasSubmitting.current = isSubmitting;
  }, [isSubmitting, id, dispatch]);
}
